import { useLanguage } from "@utils/hooks/useLanguage";
import { IPlayer } from "@components/StatsConsole/Widgets/LineupWidget/parts/Players";
import HorizontalListWithArrows from "@components/StatsConsole/Widgets/LineupWidget/parts/HorizontalLists/HorizontalListWithArrows";
import { useTranslations } from "../../../../../translation/TranslationContext";
import { useContext } from "react";
import { StateContext } from "../../../../../state/stateContext";
import { sortPlayers } from "@components/StatsConsole/Widgets/LineupWidget/parts/HorizontalLists/hooks/sortingPlayers";

interface MissingPlayersProps {
    homePlayers: IPlayer[];
    awayPlayers: IPlayer[];
    homeTeamName?: string | null;
    awayTeamName?: string | null;
}

const MissingPlayers = ({ homePlayers, awayPlayers, homeTeamName, awayTeamName }: MissingPlayersProps) => {
    const language = useLanguage();
    const t = useTranslations(language);
    const ctx = useContext(StateContext);
    const { stContext } = ctx || {};
    const { activeTooltipPlayerId } = stContext || {};

    const hasHomeInjuriesData = homePlayers && homePlayers.length > 0 && 
        homePlayers.some(player => (player.redCard || player.injury));
    
    const hasAwayInjuriesData = awayPlayers && awayPlayers.length > 0 && 
        awayPlayers.some(player => (player.redCard || player.injury));

    if (!hasHomeInjuriesData && !hasAwayInjuriesData) {
        return null;
    }

    const sortedAwayPlayers = sortPlayers(awayPlayers, true);
    
    const hasMorePlaceForTooltip = activeTooltipPlayerId && 
        sortedAwayPlayers.some((player, index) => `${index}${player.name}` === activeTooltipPlayerId);
    
    const containerHeight = hasMorePlaceForTooltip ? '310px' : '248px';

    return (
        <div data-testid="injuries-container" className={`bg-monoY dark:bg-base110 mt-[8px] rounded-[4px] overflow-visible transition-all duration-300`}
            style={{ 
                height: containerHeight,
                minHeight: containerHeight
            }}>
            <div data-testid="injuries-title" className="w-full h-[24px] flex justify-center items-center mt-[12px] mb-[8px]
                            font-medium text-[16px] leading-[24px] text-monoX dark:text-monoY ">
                {/* {t[`InHouseStats.LineupInjuries`]} */}
                Missing Players
            </div>
            <div data-testid="injuries-home-team-name" className={`ml-[8px] w-full font-medium text-[12px] leading-[16px] text-monoX dark:text-monoY mb-[4px] pr-[16px] truncate`}>
                {homeTeamName}
            </div>
            <HorizontalListWithArrows mb="mb-[16px]" players={homePlayers} isInjuries={false} name={homeTeamName} team="home"/>
            <div data-testid="injuries-away-team-name" className={`ml-[8px] w-full font-medium text-[12px] leading-[16px] text-monoX dark:text-monoY mb-[4px] pr-[16px] truncate`}>
                {awayTeamName}
            </div>
            <HorizontalListWithArrows mb="mb-[12px]" players={awayPlayers} isInjuries={true} name={awayTeamName} team="away"/>
        </div>
    )
}

export default MissingPlayers;